import { translate } from "../../../../../../../common/providers";

export const PACKAGE_ICONS = [
	"faTrophy",
	"faLightbulb",
	"faLandmark",
	"faHammer",
	"faDatabase",
	"faThumbtack",
	"faStopwatch",
	"faBookmark",
	"faSitemap",
	"faShieldHalved",
	"faSquarePollVertical",
	"faScrewdriverWrench",
	"faTicketSimple",
	"faClipboardCheck",
	"faFlaskVial",
	"faStairs",
	"faPaperPlane",
	"faPenRuler",
];

export const SUPPORTED_LANGUAGES = [
	{ code: "fr", labelKey: "dsi.package-management.panel.info.language.fr" },
	{ code: "en", labelKey: "dsi.package-management.panel.info.language.en" },
	{ code: "es", labelKey: "dsi.package-management.panel.info.language.es" },
];

const camelToKebab = (str) => str.replace(/([A-Z])/g, "-$1").toLowerCase();

export const getPlaceholder = (field, langCode) => {
	const kebabField = camelToKebab(field);
	return translate(`dsi.package-management.panel.info.placeholder.${kebabField}.${langCode}`);
};
